import { FC, useCallback } from 'react';
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tooltip,
  Typography,
} from '@mui/material';
import { splitLongNames } from 'string-utils';

const FilesSelector: FC<React.PropsWithChildren<FilesSelectorProps>> = ({
  files,
  index,
  handleChange,
}) => {
  const onFileChange = useCallback(
    (event: SelectChangeEvent) => {
      handleChange(
        event as React.SyntheticEvent,
        parseInt(event?.target.value),
      );
    },
    [handleChange],
  );

  return (
    <Box
      display='flex'
      mb={1}
      alignItems='center'
      width='100%'
      justifyContent='space-between'
      flexDirection='row'>
      <Tooltip title={<Typography variant='body2'>{files[index]}</Typography>}>
        <Typography variant='h6' sx={{ maxWidth: 800 }}>
          {splitLongNames(files[index], 80)}
        </Typography>
      </Tooltip>

      {files.length > 1 && (
        <Select
          onChange={onFileChange}
          defaultValue=''
          value={index.toString()}
          sx={{ maxWidth: 600 }}>
          {files.map((file, fileIndex) => (
            <MenuItem key={fileIndex} value={fileIndex.toString()}>
              {splitLongNames(file, 100)}
            </MenuItem>
          ))}
        </Select>
      )}
    </Box>
  );
};

export interface FilesSelectorProps {
  files: string[];
  index: number;
  handleChange: (
    _: React.SyntheticEvent<Element, Event>,
    newValue: number,
  ) => void;
}

export default FilesSelector;
